import { ServerRequest } from '@nutshell/core';

export default {
	install: (app, options) => {
		options ??= {};

		let _xhr = new ServerRequest(options);

        /**
		 * Adding XHR Class to Vue Instance
		 */
		app.config.globalProperties.$xhr = _xhr;

		/**
		 * Adding XHR Class to Store
		 */
		if ( app.config.globalProperties.$store ) {
			app.config.globalProperties.$store.$xhr = _xhr;
		}
	}
}


/*
---
name: XML Http Request
category: Application
subcategory: Vue
---

Adding the ServerRequest from @nutshell/core to your Vue project. Your ServerRequest is now available as this.$xhr in all Vue components.

```js
import { createApp, h } from 'vue';
import { VueServerRequest } from '@nutshell/vue';

const vueApp = createApp({
	render: () => h(App)
});

vueApp.use(VueServerRequest);

```

```js
//usage Examples
<script>
export default {
	mounted() {

		this.$xhr.post('method', {example: 'test'}).then( ( {result} ) => {
			//Do success action
		}).catch( () => {
			//Do error
		});
	}
}
</script>
```
*/
